import React, { useEffect } from "react";
import * as Constant from "../../../../constants";
import {
  TextField,
  Button,
  InputLabel,
  Grid,
  Box,
} from "@material-ui/core";
import DynamicTextField from "../../../DynamicTextField";
import { useFormikContext } from "formik";
import Stepper from "react-stepper-horizontal";
import CustomPopover from "../../../Popover/Popover";

const Step3 = (props) => {

  const { values } = useFormikContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (key, value) => {
    props.setFormState({ ...props.formState, [key]: value });
  };
  
  return (
    <div>
      <Stepper
        titleFontSize={12}
        steps={[
          { title: "Application" },
          { title: "Inscription" },
          { title: "Course" },
        ]}
        activeStep={2}
      />
      <h2>Configuration de vos courses</h2>
      <h4>
        <i>un parcours = une course</i>
      </h4>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box mt={2}>
            <InputLabel
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              Téléchargez vos traces GPX complètes (le départ et Arrivée ne
              doivent pas être au même endroit).
              <CustomPopover>
                <p>
                  <i>
                    Une trace GPX correspond à votre parcours, donc à votre
                    course.
                  </i>
                </p>
              </CustomPopover>
            </InputLabel>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <DynamicTextField
            setFieldValue={props.setFieldValue}
            handleChange={handleChange}
            values={values}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            name="otherAsk"
            label="Demandes complémentaires"
            value={props.formState.otherAsk}
          />
        </Grid>
        <Grid container justify="flex-end">
          <Box my={2}>
            {props.hasPrev() && (
              <Button
                className="bottom-button"
                size="small"
                onClick={props.prev}
                variant="outlined"
                color="primary"
              >
                Précédent
              </Button>
            )}
            {props.hasNext() && (
              <Button
                className="bottom-button"
                size="small"
                onClick={props.next}
                variant="contained"
                color="primary"
              >
                Suivant
              </Button>
            )}
          </Box>
        </Grid>
        <i style={{ opacity: "0.6", fontSize: "12px" }}>* Champ Obligatoire</i>
      </Grid>
    </div>
  );
};

export default Step3;
